export const filtersOptions = ['24H', '7D', '30D']
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000
export const ONE_WEEK_IN_MS = 7 * ONE_DAY_IN_MS
export const ONE_MONTH_IN_MS = 30 * ONE_DAY_IN_MS

export enum FilterDate {
    H24 = '24h',
    D7 = '7d',
    D30 = '30d',
}